/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"
import { ProcessFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type ProcessQueryVariables = Exact<{
  id: string
}>

export type ProcessQuery = {
  __typename: "Query"
  process: {
    __typename: "Process"
    id: string
    copyId?: string | null
    createdAt?: string | null
    error?: string | null
    finished?: boolean | null
    originId?: string | null
    originType?: string | null
    targetId?: string | null
    targetType?: string | null
    updatedAt?: string | null
    options?: {
      __typename: "ProcessOptions"
      recursive?: boolean | null
    } | null
  }
}

export const ProcessDocument = gql`
  query Process($id: ID!) {
    process(id: $id)
      @rest(
        type: "Process"
        endpoint: "processes"
        path: "/project-list/processes/{args.id}"
      ) {
      ...Process
    }
  }
  ${ProcessFragmentDoc}
`

/**
 * __useProcessQuery__
 *
 * To run a query within a React component, call `useProcessQuery` and pass it any options that fit your needs.
 * When your component renders, `useProcessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProcessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProcessQuery(
  baseOptions: Apollo.QueryHookOptions<ProcessQuery, ProcessQueryVariables> &
    ({ variables: ProcessQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProcessQuery, ProcessQueryVariables>(
    ProcessDocument,
    options
  )
}
export function useProcessLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProcessQuery, ProcessQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProcessQuery, ProcessQueryVariables>(
    ProcessDocument,
    options
  )
}
// @ts-ignore
export function useProcessSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProcessQuery,
    ProcessQueryVariables
  >
): Apollo.UseSuspenseQueryResult<ProcessQuery, ProcessQueryVariables>
export function useProcessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProcessQuery, ProcessQueryVariables>
): Apollo.UseSuspenseQueryResult<
  ProcessQuery | undefined,
  ProcessQueryVariables
>
export function useProcessSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ProcessQuery, ProcessQueryVariables>
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProcessQuery, ProcessQueryVariables>(
    ProcessDocument,
    options
  )
}
export type ProcessQueryHookResult = ReturnType<typeof useProcessQuery>
export type ProcessLazyQueryHookResult = ReturnType<typeof useProcessLazyQuery>
export type ProcessSuspenseQueryHookResult = ReturnType<
  typeof useProcessSuspenseQuery
>
export type ProcessQueryResult = Apollo.QueryResult<
  ProcessQuery,
  ProcessQueryVariables
>
